import { AppointmentType } from '@dialogue/timekeeper'

import { useSelector } from 'APP/Hooks/redux'
import { selectPatientProfile } from 'APP/Redux/PatientRedux'
import {
  selectAppointmentTypes,
  selectAppointmentTypesFetched,
  selectLoadingAppointmentTypes,
} from 'APP/Store/ProviderBooking/selectors'

import { PROVIDER_SELECTION_FEATURE_NAME } from '../constants'

export type ProviderSelectionState = {
  hasProviderSelection: boolean
  showProviderSelection: boolean
  isLoadingTypes: boolean
  hasFetchedTypes: boolean
}

/**
 * Hook exposing the provider-selection logic, for a given appointment type.
 *
 * Used by the base view to pick the correct inner component.
 */
export const useProviderSelection = (appointmentType: AppointmentType): ProviderSelectionState => {
  const profile = useSelector(selectPatientProfile)
  const appointmentTypes = useSelector(selectAppointmentTypes)
  const isLoadingTypes = useSelector(selectLoadingAppointmentTypes)
  const hasFetchedTypes = useSelector(selectAppointmentTypesFetched)

  const hasProviderSelection = !!profile?.eligibleServices?.[PROVIDER_SELECTION_FEATURE_NAME]
  const showProviderSelection = hasProviderSelection && appointmentTypes.includes(appointmentType)

  return { hasProviderSelection, showProviderSelection, isLoadingTypes, hasFetchedTypes }
}
